import React from 'react';

export const ClaimScore = () => (
  <svg
    width="22"
    height="21"
    viewBox="0 0 22 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.3377 0.483422V3.04702C15.3377 3.31071 15.1253 3.53045 14.8542 3.53045H9.13375C6.21124 3.53045 4.2629 5.50808 4.07246 8.62835C4.05782 8.88471 3.85273 9.0898 3.59637 9.0898H0.483422C0.219737 9.0898 0 8.87739 0 8.60638C0 3.85273 3.85273 0 8.60638 0H14.8616C15.1253 0 15.345 0.212413 15.345 0.483422H15.3377ZM6.11602 8.56975C6.09405 8.84809 6.31379 9.08247 6.59212 9.08247H20.7286C20.9922 9.08247 21.212 8.87006 21.212 8.59905V6.02813C21.212 5.76444 20.9996 5.5447 20.7286 5.5447H9.14107C6.84115 5.5447 6.24054 7.23668 6.11602 8.56243V8.56975ZM15.096 11.6241C15.1179 11.3458 14.8982 11.1114 14.6199 11.1114H0.483422C0.219737 11.1114 0 11.3238 0 11.5948V14.1657C0 14.4294 0.212413 14.6492 0.483422 14.6492H12.0782C14.3781 14.6492 14.9788 12.9572 15.1033 11.6314L15.096 11.6241ZM17.6156 11.1114C17.3592 11.1114 17.1542 11.3165 17.1395 11.5728C16.9491 14.6858 15.0007 16.6707 12.0782 16.6707H7.05357C6.78988 16.6707 6.57015 16.8832 6.57015 17.1542V19.7178C6.57015 19.9814 6.78256 20.2012 7.05357 20.2012H13.0963C17.5863 20.2012 21.2193 16.5609 21.2193 12.0782V11.6021C21.2193 11.3384 21.0069 11.1187 20.7359 11.1187H17.6156V11.1114Z"
      fill="#231F20"
    />
  </svg>
);
